export default "__VITE_ASSET__BJvIkfSf__"